import React from "react";
import { FallbackProps } from "react-error-boundary";
import { useCopilotChat } from "@copilotkit/react-core";

import { StriimButton, StriimFeedbackBlock, StriimTypography } from "@striim/striim-ui";
import { Box } from "@mui/material";
import { AI_AGENT_NAME } from "../../ai-constants";

const styles = {
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        height: "100%",
        padding: 3
    }
};

const ChatErrorFallback: React.FC<FallbackProps> = ({ resetErrorBoundary }) => {
    const { visibleMessages, reloadMessages } = useCopilotChat();

    // Chat-level boundary catches non-message render crashes. "Try Again" reloads the chat by
    // regenerating the last message (keeping history) and then re-rendering the chat content.
    // Per-message errors are handled in CustomAssistantMessage, where "Try Again" asks the LLM
    // to redo that specific response.
    const handleTryAgain = () => {
        const lastMessage = visibleMessages?.[visibleMessages.length - 1];
        if (lastMessage?.id) {
            void reloadMessages(lastMessage.id);
        }
        resetErrorBoundary();
    };
    return (
        <Box sx={styles.container} data-test-id="striim-ai-chat-error">
            <StriimFeedbackBlock
                variant="critical"
                content={
                    <>
                        <StriimTypography
                            variant="body4"
                            color="greyscale.800"
                            data-test-id="striim-ai-chat-error-message"
                        >
                            {AI_AGENT_NAME} ran into a problem displaying this conversation.
                        </StriimTypography>
                    </>
                }
            />
            <StriimButton variant="primary" size="small" onClick={handleTryAgain} data-test-id="striim-ai-chat-retry">
                Try again
            </StriimButton>
        </Box>
    );
};

export default ChatErrorFallback;
